import { useState } from "react";
import { Save, RotateCcw, Globe } from "lucide-react";

/** Iter 159 — Editor ES de los textos de la página pública del presupuesto. */
export function PublicTextsEditor({ tpl, sections, onSave, onReset }) {
  const [form, setForm] = useState({ ...tpl });
  const dirty = Object.keys(form).some((k) => form[k] !== tpl[k]);

  const save = async () => {
    const texts = Object.fromEntries(Object.entries(form).filter(([k, v]) => v !== tpl[k]));
    const r = await onSave({ texts });
    if (r) setForm({ ...form });
  };

  return (
    <div className="ds-card p-5 space-y-5" data-testid="public-texts-editor">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#6E8B3D]">// Página pública</div>
          <div className="font-display font-bold text-xl mt-1 inline-flex items-center gap-2"><Globe size={18} /> Presupuesto público</div>
          <p className="text-xs text-[#525252] mt-1">
            Textos que ve el cliente en /presupuesto/:token. Versión maestra en español; al guardar se actualizan las traducciones de los idiomas activos.
            Los marcadores <code className="font-mono">{"{{fecha}}"}</code> y <code className="font-mono">{"{{n}}"}</code> se sustituyen automáticamente.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={onReset} data-testid="public-texts-reset"
            className="border border-[#111110] hover:bg-[#111110] hover:text-white px-3 py-2 text-xs font-mono uppercase inline-flex items-center gap-1">
            <RotateCcw size={12} /> Restaurar
          </button>
          <button onClick={save} disabled={!dirty} data-testid="public-texts-save"
            className="bg-[#6E8B3D] hover:bg-[#556C2E] disabled:bg-[#A8A8A0] text-white px-3 py-2 text-xs font-mono uppercase inline-flex items-center gap-1">
            <Save size={12} /> Guardar
          </button>
        </div>
      </div>

      {sections.map((sec) => (
        <section key={sec.key} className="border border-[#E5E5E0] bg-white p-4" data-testid={`public-section-${sec.key}`}>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#6E8B3D] mb-3">{sec.label}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {sec.keys.map((k) => (
              <label key={k} className="block">
                <span className="font-mono text-[10px] text-[#525252]">{k}</span>
                <input
                  value={form[k] ?? ""}
                  onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                  data-testid={`public-text-${k}`}
                  className="mt-0.5 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-1.5 text-sm rounded-none"
                />
              </label>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
